const TOKEN_KEY = 'ofrontend.sessionToken';
const REFRESH_TOKEN_KEY = 'ofrontend.refreshToken';
const USER_NAME_KEY = 'ofrontend.userName';
const LOGIN_TYPE_KEY = 'ofrontend.loginType';
/** Email/username the user typed at login — restores the login form default after reload. */
const LOGIN_IDENTIFIER_KEY = 'ofrontend.loginIdentifier';

function safeGet(key: string): string | null {
  try {
    return localStorage.getItem(key)?.trim() || null;
  } catch {
    return null;
  }
}

function safeSet(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* ignore */
  }
}

function safeRemove(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

export function getSessionToken(): string | null {
  return safeGet(TOKEN_KEY);
}

/** Refresh JWT/string returned by login or rotated by POST `/auth/refresh` (persists across reloads). */
export function getStoredRefreshToken(): string | null {
  return safeGet(REFRESH_TOKEN_KEY);
}

export function persistStoredRefreshToken(refreshToken: string): void {
  const t = refreshToken.trim();
  if (t) {
    safeSet(REFRESH_TOKEN_KEY, t);
  }
}

export function clearStoredRefreshToken(): void {
  safeRemove(REFRESH_TOKEN_KEY);
}

export function getStoredUserName(): string | null {
  return safeGet(USER_NAME_KEY);
}

export function getStoredLoginType(): string | null {
  return safeGet(LOGIN_TYPE_KEY);
}

export function getStoredLoginIdentifier(): string | null {
  return safeGet(LOGIN_IDENTIFIER_KEY);
}

export function persistSession(
  accessToken: string,
  displayName: string,
  loginType: string,
  loginIdentifier?: string,
): void {
  safeSet(TOKEN_KEY, accessToken);
  safeSet(USER_NAME_KEY, displayName);
  safeSet(LOGIN_TYPE_KEY, loginType);
  const id = loginIdentifier?.trim();
  if (id) {
    safeSet(LOGIN_IDENTIFIER_KEY, id);
  }
}

/** After `/auth/refresh` — new access token only; keeps name and login type. */
export function persistAccessTokenOnly(accessToken: string): void {
  const t = accessToken.trim();
  if (t) {
    safeSet(TOKEN_KEY, t);
  }
}

/** Update greeting label after profile load/edit without touching token or login type. */
export function persistUserNameOnly(displayName: string): void {
  const name = displayName.trim();
  if (name) {
    safeSet(USER_NAME_KEY, name);
  }
}

export function clearPersistedSession(): void {
  safeRemove(TOKEN_KEY);
  safeRemove(REFRESH_TOKEN_KEY);
  safeRemove(USER_NAME_KEY);
  safeRemove(LOGIN_TYPE_KEY);
  safeRemove(LOGIN_IDENTIFIER_KEY);
}
